import {
  FunctionComponent,
  MouseEventHandler,
  MouseEvent,
  MutableRefObject
} from 'react'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import { dismissPopover } from 'services/OverlayService'
import IconButton from '@material-ui/core/IconButton'

const PDFButton: FunctionComponent<PDFButtonProps> = ({
  pdfUrl,
  isLogged,
  setSignUpModalIsOpen
}: PDFButtonProps) => {
  const handleOnClick: MouseEventHandler<HTMLButtonElement> = (e: MouseEvent<HTMLElement>) => {
    dismissPopover(e.target)
    e.preventDefault()
    e.stopPropagation()
    setSignUpModalIsOpen(true)
  }

  return (
    <div className='mh2 mh1-m'>
      <IconButton
        size='small'
        data-event-category='Download'
        data-event-action='PDF'
        data-event-label={pdfUrl}
        classes={{ root: 'black', sizeSmall: 'f3 f4-t f5-m' }}
        {...(isLogged ? {
          href: pdfUrl,
          download: true
        } : {
          onClick: handleOnClick
        })}
        >
        <PictureAsPdfIcon fontSize='inherit' className='vm' />
      </IconButton>
    </div>
  )
}

interface PDFButtonProps {
  pdfUrl: string;
  hidden: MutableRefObject<any>;
  isLogged: boolean;
  setSignUpModalIsOpen: (value: boolean) => void
}

export default PDFButton
